import { cn } from "@/lib/cn";

export interface StepperProps {
  steps: number;
  current: number;
  className?: string;
}

/** 4-dot stepper joined by 1px lines — DESIGN.md §9. */
export function Stepper({ steps, current, className }: StepperProps) {
  return (
    <ol className={cn("flex items-center", className)} aria-label={`Step ${current + 1} of ${steps}`}>
      {Array.from({ length: steps }, (_, i) => {
        const state = i < current ? "done" : i === current ? "current" : "todo";
        return (
          <li key={i} className="flex flex-1 items-center last:flex-none">
            <span
              aria-current={state === "current" ? "step" : undefined}
              className={cn(
                "size-2.5 shrink-0 rounded-full",
                state === "done" && "bg-primary",
                state === "current" && "bg-surface-1 ring-2 ring-primary",
                state === "todo" && "bg-surface-1 ring-1 ring-border-strong",
              )}
            />
            {i < steps - 1 && <span className={cn("mx-2 h-px flex-1", state === "done" ? "bg-primary" : "bg-border")} />}
          </li>
        );
      })}
    </ol>
  );
}
